import React, { useEffect, useMemo, useState } from 'react'
import redirectURL from "../redirectURL";
import { Modal } from 'react-bootstrap';
import ImageCarousel from './ImageCarousel'
import axios from 'axios'; // or use your configured redirectURL instance
import { AgGridReact } from 'ag-grid-react';
import { use } from 'react';


export default function OtrView({ showOtr, onClose, data }) {
    const [tabs, setTab ] = useState({value: "otr_details"})
    const [rowData, setRowData] = useState([])
    let otr_data = {};
    const [imageUrl, setImageUrl] = useState(null);
    const [showImage, setShowImage] = useState(false)
    const [image, setImage] = useState(null)
    const defaultColDef = useMemo(() => {
            return {
                sortable: true,
                filter: true,
                autoSizeColumns: true,
                resizable: true,
                pivot: true,
            }
        }, []);
    const colDefs = useMemo(()=>{ return [
             {
            headerName: "",
            field: "",
            suppressMenu: true,
             pinned: "left",
            width:50,
            cellRenderer: (params) => {
                    return (
                        <i className="icon-eye" title='View' onClick={params.data.type==="Damage" && (params.data?.file != null || params.data?.file !=undefined)? (e) => onClickViewImage(e, params):null} style={{ fontSize: "12px",cursor: params.data.type === "Damage" && (params.data?.file != null || params.data?.file !=undefined)? "pointer" : "not-allowed",
      color: params.data.type === "Damage" && (params.data?.file != null || params.data?.file !=undefined) ? "#000000" : "#ccc"}}></i>
                    )},
                    cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            
            },
            {
                headerName: "",
                field: "",
                width:50,
                suppressMenu:true,
                pinned:"left",
                cellRenderer: (params) => {
                    return (
                        <i className="fa fa-download" title="Download" onClick={params.data.type==="Damage" && (params.data?.file != null || params.data?.file !=undefined)? (e) => viewDownload(e, params):null} style={{ fontSize: "12px",cursor: params.data.type === "Damage" && (params.data?.file != null || params.data?.file !=undefined)? "pointer" : "not-allowed",
      color: params.data.type === "Damage" && (params.data?.file != null || params.data?.file !=undefined) ? "#000000" : "#ccc"}}></i>
                    );}},
            {
                headerName: "Seal Intact",
                field: "seal_intact",
                editable: false,
                width:150
            },
            {
                headerName: "Type",
                field: "type",  
                editable: false,
                width:120
            },
            {
                headerName: "Product ID",
                field: "product",
                editable: false,
                width:140
            },
            {
                headerName: "Quantity",
                field: "quantity",
                editable: false,
                 width:120
            },
            {
                headerName: "Unit Of Measure",
                field: "unit_of_measure",
                editable: false,
                width:150
            },
            {   
                headerName: "Challan Batch",
                field: "challan_batch",
                editable: false,
                width:150
            },
            {
                headerName: "Challan Receipt",
                field: "challan_receipt",
                editable: false,
                width:150
            },
            {
                headerName: "Reason Code",
                field: "reason",
                editable: false,
                width:150
            },
            {
                headerName: "Comments",
                field: "comments",
                editable: false,
                width:150
            },

        ]})
    const otrdata = useMemo(() => {
            const item = data || {};

            try {
                otr_data = item?.otr_details ?? {}
            } catch (err) {
                console.error("Error parsing checklist:", err);
            }
            let damage = (otr_data?.damage ?? []).map(each => ({...each,type: "Damage"}));

            let shortage = (otr_data?.shortage ?? []).map(each => ({...each,type: "Shortage"}));

            let mismatch = (otr_data?.mismatch ?? []).map(each => ({...each,type: "Mismatch"}));

            let otr_files = otr_data?.otr_files ?? []
            if (otr_files.length > 0) {
            damage = damage.map(item => {
                const matchedFile = otr_files.find(f => f.product === item.product);
                
                return {
                ...item,
                file: matchedFile ? matchedFile.file : null
                };
            });
            }

            setRowData([...damage, ...shortage, ...mismatch]);
            
            return {
                ...otr_data,
                truck_no: item.truck_no ?? '-',
                fo_number: item.fo_number ?? "-"
                
            }
        }, [data]);

    const tabChange = (value)=>{
        console.log("tab changes", value)
        setTab({value})
    }

    const modalClose = ()=>{
        onClose()
    }

    const onClickViewImage = (e,params)=>{
        e.preventDefault()
        let  param = {
                    fileName: [params.data.file]
                };
        redirectURL.post('/getChecklistImages', param)
                    .then(response => {
                        console.log(response.data, "response")
                        if (response.data.message === "Success") {
                            let urls = response.data?.data?.map(item => item.url);
                            console.log("urls", urls)
                            const downloadUrl = urls[0];
                            const fileName = data.fo_number + "_"+ "damage" + "_"+params.data.product
            
                    const link = document.createElement("a");
                    link.href = downloadUrl;
                    link.setAttribute("download", fileName); 
                    link.setAttribute("target", "_blank");
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                        } 
                    })
                    .catch(err => {
                        console.log("error fecting url", err)
                    });
    }
    const viewDownload = async (e, params) => {
  e.preventDefault();

   let  param = {
                    fileName: [params.data.file], download:1
                };
        redirectURL.post('/getChecklistImages', param)
                    .then(response => {
                        console.log(response.data, "response")
                        if (response.data.message === "Success") {
                            let urls = response.data?.data?.map(item => item.url);
                            const downloadUrl = urls[0];
                            const fileName = data.fo_number + "_"+ "damage" + "_"+params.data.product
            
                    const link = document.createElement("a");
                    link.href = downloadUrl;
                    link.setAttribute("download", fileName); 
                    link.setAttribute("target", "_blank");
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                        } 
                    })
                    .catch(err => {
                        console.log("error fecting url", err)
                    });
};

    const otrImages = () => {
        try {
            console.log("otr images")
            let param = {}
            if (showImage) {
                    param = {
                    fileName: [image]
                };
                
                redirectURL.post('/getChecklistImages', param)
                    .then(response => {
                        if (response.data.message === "Success") {
                            const urls = response.data?.data?.map(item => item.url);
                            setImageUrl(urls);
                        } else {
                            setImageUrl([]);
                        }
                    })
                    .catch(err => {
                        setImageUrl([]);
                    });
            } else {
                setImageUrl([]);
            }
        } catch (e) {
            setImageUrl([]);
        }
    }

     useEffect(() => {
            if (showImage) {
                console.log("useeffect")
                otrImages();
            }
    }, [ showImage]);

    return<>
    {showOtr && ( <Modal
                    onHide={modalClose}
                    dialogClassName="checklist_modal"
                    show={showOtr}
                    centered>
                    <Modal.Header  className="position-relative">
                        <Modal.Title className="w-100 text-center">OTR: {data.otr_no}</Modal.Title>
                        
                        <div className="btn-box d-flex gap-3">
                            <button type="button" className="btn btn-sm btn-icon btn-outline-primary" data-bs-dismiss="modal" aria-label="Close" onClick={modalClose}>
                                <i className="fa fa-times"></i>
                            </button>
                        </div>
                    </Modal.Header> 
                    <Modal.Body style={{backgroundColor:'#e4e4e4'}}>
                        <div className="card">
                            <div className='card-body'>
                                
                                <div className='d-flex justify-content-between'>
                                    <div>
                                        <div style={{ justifyContent: "flex-start", gap: "8px", marginBottom:"10px"}}>
                                            <span style={{ width: "120px", fontWeight:"bold"}}>FO Number</span>
                                            <span style={ { width: "10px", textAlign: "center", padding:"3px"}}>:</span>
                                            <span style={{ flex: 1 }}>{data.fo_number}</span>
                                        </div>
                                        <div style={{ justifyContent: "flex-start", gap: "8px" }}>
                                            <span style={{ width: "120px", fontWeight:"bold"}}>Truck No</span>
                                            <span style={ { width: "10px", textAlign: "center", padding:"3px"}}>:</span>
                                            <span style={{ flex: 1 }}>{data.truck_no}</span>
                                        </div>
                                    </div>
                                    <div>
                                        <div style={{ justifyContent: "flex-start", gap: "8px", marginBottom:"10px"}}>
                                            <span style={{ width: "120px", fontWeight:"bold"}}>LR No</span>
                                            <span style={ { width: "10px", textAlign: "center", padding:"3px"}}>:</span>
                                            <span style={{ flex: 1 }}>{otrdata.lr_no}</span>
                                        </div>
                                        <div style={{ justifyContent: "flex-start", gap: "8px" }}>
                                            <span style={{ width: "120px", fontWeight:"bold"}}>Container No</span>
                                            <span style={ { width: "10px", textAlign: "center", padding:"3px"}}>:</span>
                                            <span style={{ flex: 1 }}>{otrdata.container_no}</span>
                                        </div>
                                    </div>
                                    <div>
                                        <div style={{ justifyContent: "flex-start", gap: "8px", marginBottom:"10px"}}>
                                            <span style={{ width: "120px", fontWeight:"bold"}}>Checking Done</span>
                                            <span style={ { width: "10px", textAlign: "center", padding:"3px"}}>:</span>
                                            <span style={{ flex: 1 }}>{otrdata.checking_done}</span>
                                        </div>
                                        <div style={{ justifyContent: "flex-start", gap: "8px" }}>
                                            <span style={{ width: "120px", fontWeight:"bold"}}>Prepared By</span>
                                            <span style={ { width: "10px", textAlign: "center", padding:"3px"}}>:</span>
                                            <span style={{ flex: 1 }}>{otrdata.prepared_by}</span>
                                        </div>
                                    </div>
                                </div> 
                                <div className="d-flex justify-content-end mt-3"
                                    style={{ fontSize: "18px", fontWeight: "400", lineHeight: "1.5" }}>

                                <button type="button" className="btn btn-default mybtn mr-2">
                                    <i className="icon-eye"></i>&nbsp;&nbsp;View
                                </button>

                                <button type="button" className="btn btn-default mybtn">
                                    <i className="fa fa-download"></i>&nbsp;&nbsp;Download
                                </button>

                                </div>
                                <div className={"ag-theme-balham mt-8"} style={{ height: '400px', width: '100%', paddingTop: "1rem" }}>
                                <AgGridReact columnDefs={colDefs} rowData={rowData} defaultColDef={defaultColDef}/>
                            </div>
                            </div>
                            </div>
                            
                        
                        
                    </Modal.Body>
                    </Modal>)
    }</>
    

}   